import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export interface NoteListRequestArgs {
  municipalityID?: number;
  noteTempEntityID?: number;
}

const getNoteQueryStrings = (args: NoteListRequestArgs) => {
  if (args.municipalityID) {
    return `MunicipalityID=${args.municipalityID}`;
  }
  if (args.noteTempEntityID) {
    return `NoteTempEntityID=${args.noteTempEntityID}`;
  }
};

export const municipalityApiKeyStore = {
  createMunicipality: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_MUNICIPALITIES`],
    route: `/Municipality`,
    action: 'POST',
  }),
  updateMunicipality: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_MUNICIPALITIES`],
    route: `/Municipality`,
    action: 'PUT',
  }),
  deleteMunicipality: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_MUNICIPALITY`, id],
    route: `/Municipality/${id}`,
    action: 'DELETE',
  }),
  getMunicipalities: (): QueryKeyConfig => ({
    queryKey: [`GET_MUNICIPALITIES`],
    route: `/Municipality`,
  }),
  getMunicipalityByStateID: (stateID: any): QueryKeyConfig => ({
    queryKey: [`GET_MUNICIPALITY_BY_STATE_ID`, stateID],
    route: `/Municipality/GetByState/${stateID}`,
    isEnabled: !!stateID,
  }),
  getMunicipality: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_MUNICIPALITy`, id],
    route: `/Municipality/${id}`,
  }),
  getMunicipalityTemplate: (): QueryKeyConfig => ({
    queryKey: [`GET_MUNICIPALITY_TEMPLATE`],
    route: `/Municipality/CoC/Templates`,
  }),
  getMunicipalityPermitNumber: (): QueryKeyConfig => ({
    queryKey: [`GET_MUNICIPALITY_NUMBER`],
    route: `/Municipality/CoC/PermitType`,
  }),
  getDetailsByTemplateID: (municipalityID: any, TemplateID: any): QueryKeyConfig => ({
    queryKey: [`GET_DETAILS_BY_TEMPLATE_ID`, municipalityID, TemplateID],
    route: `/Municipality/MunicipalityID/${municipalityID}/CoCTemplate/${TemplateID}`,
    isEnabled: TemplateID !== 0,
  }),
  //Municipality_Notes_API's
  getMunicipalityNotes: (args: NoteListRequestArgs): QueryKeyConfig => ({
    queryKey: [
      `GET_MUNICIPALITY_NOTES`,
      ...[args.municipalityID, args.noteTempEntityID].filter(
        (a) => a
      ),
    ],
    route: `/Municipality/Notes?${getNoteQueryStrings(args)}`,
  }),
  createMunicipalityNote: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_MUNICIPALITY_NOTE`],
    route: `/Municipality/Note`,
    action: 'POST',
  }),
  updateMunicipalityNote: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_MUNICIPALITY_NOTE`],
    route: `/Municipality/Note`,
    action: 'PUT',
  }),
  deleteMunicipalityNote: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_MUNICIPALITY_NOTE`, id],
    route: `/Municipality/Note${id}`,
    action: 'DELETE',
  }),
  getMunicipalityNoteTopics: (): QueryKeyConfig => ({
    queryKey: [`GET_MUNICIPALITy_NOTES_TOPICS`],
    route: `/Municipality/NoteTopics`,
  }),
};
